import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import { styles } from './styles';
import { colors } from '../../shared/styles';
import { styles as typeaheadStyles } from '../shared/styles';
import { TypeAhead } from '../shared/TypeAhead';
import AngleRight from 'react-icons/lib/fa/angle-right';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getEventSummary } from 'athlinks-results-client';
import  SearchIcon  from 'react-icons/lib/md/search';
import { Loading } from '../shared/Loading';

class KioskSearchFormComponent extends Component {
  static propTypes = {
    eventId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    t: PropTypes.func
  };

  constructor(props, context) {
    super(props, context);
    this.documentRef = React.createRef();
    this.state = {
      doSearchAgain: false,
      emptySelected: false,
      isFirstSearch: true,
      searchTerm: '',
      staleSearch: true
    };

    this.debouncedFetch = _.debounce(this.props.getEventSummary, 1000);
  }

  componentWillUnmount() {
    this.debouncedFetch.cancel();
  }

  componentDidUpdate() {
    const { doSearchAgain, emptySelected, isFirstSearch, searchTerm, staleSearch } = this.state;
    if (this.props.isLoading && (isFirstSearch || doSearchAgain)) this.setState({isFirstSearch: false, doSearchAgain: false, staleSearch: false});
    if(this.props.isLoading && staleSearch) this.setState({staleSearch: false});
    if (emptySelected && searchTerm && !this.props.isLoading) this.selectBestMatch();
  }

  openFullscreen = async (e) => {
    const elem = window.document.documentElement;
    if (elem.requestFullscreen) {
      return await elem.requestFullscreen();
    }
  }

  render () {
    const {
      isLightMode,
      isLoading,
      results,
      t
    } = this.props;

    let {emptySelected, searchTerm, staleSearch} = this.state;
    let flattenedResults = flatten(results).map((result) => { return { ...result, eventId: this.props.eventId } });

    return (
      <div
        style={styles.searchInputContainer}
        id='kioskInputContainer'
        ref={this.documentRef}
        onClick={this.openFullscreen}
      >
        <div
          style={{width:'60em',...styles.card(isLightMode)}}>
          <div>
            <h3 style={styles.searchFormHeading(isLightMode)}>
              {t('Find Your Result')}
            </h3>
          </div>
          <div style={{ position: 'relative' }}>
          <TypeAhead
            useMaterialUi={true}
            value={searchTerm}
            dropdownHeight={400}
            dropdownTop={50}
            hideDropdownOverride={!searchTerm || staleSearch}
            showDropdownOverride={emptySelected}
            width={'100%'}
            options={searchTerm ? flattenedResults : []}
            dropdownStyle={
              typeaheadStyles.typeAhead.infiniteScrollStyle(47, 'auto',
              styles.searchSuggestionDropdown(isLightMode))
            }
            renderOption={TypeaheadOption.bind(this)}
            onChange={this.onTyped}
            onOptionSelected={this.onOptionSelected}
            searching={isLoading}
            keyboardNavigation={true}
            placeholder={t('Search for your Name or Bib Number')}
            inputStyle={styles.searchInput(isLightMode)}
            inputProps={{
              style: { display: 'flex', justifyContent: 'center' },
              className: `${isLightMode ? '' : 'darkVersion'}`,
              fullWidth: true,
              disableUnderline: true,
              }
            }
            loadingOption={TypeaheadLoader.bind(this)}
            onEmptySelection={this.onEmptySelection}
            autoFocus={true}
            InputIcon={() => <SearchIcon
              style={{
                color: `${ isLightMode ? colors.grey : 'white' }`,
              }}
              size={25}
            />}
          />
          
          </div>
        </div>
      </div>
    );
  }

  doFetch = (searchTerm = '') => {
    const term = searchTerm || this.state.searchTerm;
    const limit = 20;
    this.debouncedFetch({eventId: this.props.eventId, searchTerm: term, limit});
  };

  //text was typed into input
  onTyped = (e) => {
    //TODO ideally this could be a controlled component to make it more generic, but since
    //it's only used by EventResults for now, just do a specific thing on typing/picking option
    this.setState({searchTerm: e.target.value, emptySelected: false, staleSearch: true});
    this.doFetch(e.target.value);
  };

  //clicked on an option or keyed Enter on a focused option
  // As long as the TypeAhead component is creating React Links in the dropdown list, this is an unecessary callback
  onOptionSelected = (option) => {
    this.props.onOptionSelected(option)
  };

  onEmptySelection = () => {
    this.setState({emptySelected: true, doSearchAgain: true});
    this.doFetch()
  };

  selectBestMatch = () => {
    const { results } = this.props;
    if(results && results.length) {
      const { bib, eventCourseId } = this.findBestMatch();
      if(bib) {
        this.onOptionSelected({ bib, eventCourseId });
      }
    }
  };

  findBestMatch = () => {
    const { results = [] } = this.props;
    const { searchTerm, staleSearch } = this.state;
    const defaultReturn = { bib: null, displayName: null };

    const resultSearchExact = results.find(
      ({ bib, displayName }) => bib === searchTerm
        || displayName.toLowerCase() === searchTerm.toLowerCase()
    );

    if(resultSearchExact) {
      return resultSearchExact
    } else {
      const partialMatch = results.find(
        ({ displayName }) => displayName.toLowerCase().split(' ').includes(searchTerm.toLowerCase())
      );

      return partialMatch && !staleSearch && results.length === 1 ? partialMatch : defaultReturn;
    }

  };
}

function TypeaheadLoader () {
  const { isLightMode, isLoading, t } = this.props;
  const { doSearchAgain, isFirstSearch } = this.state;

  return isLoading || isFirstSearch || doSearchAgain ?
  (
    <div
      style={styles.searchInputLoader}>
      <Loading/>
    </div>
  ) : (
    <div
      id='kiosk-suggestion-dropdown'
      style={{
        ...styles.searchSuggestionDropdown(isLightMode),
      }}>
      <span
        style={styles.noResultsTextContainer(isLightMode)}>
        {t('We couldn\'t find your result. Please check with the timer.')}
      </span>
    </div>
  )
}

function TypeaheadOption (
  {
    index,
    isFocused,
    isHovered,
    option,
  }) {
  if(!!_.size(option)) {
    let eventCourseName = (this.props.eventMetadata.eventCourseMetadata.find((course) => course.eventCourseId === option.eventCourseId) || {}).eventCourseName;

    return(<div style={{
        ...styles.typeaheadKioskContainer(isHovered, isFocused, this.props.isLightMode),
        borderTop: index !== 0 ? `1px solid ${colors.lightGrey4}` : 'none'
      }}>
      <div style={styles.kisokResultRow('10%', true, true)}>
        {option.bib || ''}
      </div>
      <div style={styles.kisokResultRow('42%', true)}>
        {option.displayName || ''}
      </div>
      <div style={styles.kisokResultRow('10%', true)}>
        {option.gender || ''}{option.age || ''}
      </div>
      <div style={styles.kisokResultRow('31%')}>
        {eventCourseName || ''}
      </div>
      {isHovered && <AngleRight size={30} style={{
        alignSelf: 'center',
        marginLeft: 10
      }}/> }
    </div>)
  }

  return null;
}

function flatten(results) {
  return Object.keys(results || {})
    .reduce((list, id) => list.concat(results[id]), []);
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.eventSummarySearch.errorMessage,
    isLoading: state.eventSummarySearch.isLoading,
    results: state.eventSummarySearch.results,
    eventMetadata: {...state.eventMetadata.data, eventStartDateTime: 1538336496000}
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getEventSummary: (query) => {
      dispatch(getEventSummary(query));
    }
  }
};

const KioskSearchFormConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(KioskSearchFormComponent);

export const KioskSearchForm = withTranslation()(KioskSearchFormConnected);



/** WEBPACK FOOTER **
 ** ./components/kiosk/KioskSearchForm.js
 **/